
<script setup lang="ts">
import type { CmsElementImageLeftHeadlineTextButton } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementImageLeftHeadlineTextButton;
}>();

const { headlineText, leftImage, mainText, button } = props.content.data;
</script>

<template>
  <div class="cust-2-col reverse px-4">
    <div class="container mx-auto relative py-14 md:py-24">
      <div class="col-wrap flex flex-col md:flex-row-reverse items-center">
        <!-- Text Section -->
        <div class="w-full md:w-1/2 px-4 md:pl-18 lg:pl-24 text-dark-bg mb-12 md:mb-0">
          <h3 v-if="headlineText" class="text-2xl md:text-3xl lg:text-4xl font-bold mb-4">
            {{ headlineText }}
          </h3>
          <div v-if="mainText" v-html="mainText"></div>

          <SharedButton
            v-if="button"
            :button="button"
            class="btn-default btn-red-bg py-2 px-6 md:py-4 md:px-8"
          >
          </SharedButton>
        </div>

        <!-- Image Section -->
        <div class="w-full md:w-1/2 px-4">
          <figure>
            <NuxtImg
              v-if="leftImage"
              :width="leftImage.media.metaData.width"
              :height="leftImage.media.metaData.height"
              :src="leftImage.media.url"
              :alt="leftImage.media.alt"
              format="webp"
              loading="lazy"
              class="w-full h-auto object-cover rounded-lg"
            />
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
img {
  /* gradient loader background with animation */
  background: linear-gradient(to right, #f4f3f3, #f1f1f1);
  background-size: 200% 100%;
  animation: gradient-animation 3s ease-in-out infinite;
}

@keyframes gradient-animation {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}
</style>